import React, { Component } from 'react'
import { BrowserRouter, Route, Link } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'

import Home from './pages/Home'
import Club from './pages/Club'
import Checkout from './pages/Checkout'
import Parts from './pages/Parts'
import Faq from './pages/Faq'
import Law from './pages/Law'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Sitepolicy from './pages/Sitepolicy'
import Links from './pages/Links'
import Contact from './pages/Contact'
import ForClub from './pages/ForClub'
import ForCompany from './pages/ForCompany'
import List from './pages/List'

const App = () => (
    <CookiesProvider>
        <BrowserRouter>
            <div>
                <Route exact path='/' component={Home} />
                <Route path='/faq' component={Faq} />
                <Route path='/club/:id' render={(props)=><Club {...props}/>} />
                <Route path='/checkout/:id' render={(props)=><Checkout {...props}/>} />
                <Route path='/parts' component={Parts} />
                <Route path='/law' component={Law} />
                <Route path='/privacy' component={Privacy} />
                <Route path='/terms' component={Terms} />
                <Route path='/sitepolicy' component={Sitepolicy} />
                <Route path='/link' component={Links} />
                <Route exact path='/contact' component={(props)=><Contact {...props}/>} />
                <Route path='/contact/:type' component={(props)=><Contact {...props}/>} />
                <Route path='/for-club' component={ForClub} />
                <Route path='/for-company' component={ForCompany} />
                <Route path='/list' component={List} />
            </div>
        </BrowserRouter>
    </CookiesProvider>
)


export default App